<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="专家文章列表" name="1">
        <ZjwzAdd :updataID='updataID'></ZjwzAdd>
      </el-tab-pane>
      <el-tab-pane label="添加分类" name="2"></el-tab-pane>
    </el-tabs>
</template>

<script>
/**
 * 安进
 * 专家文章修改
 */
import ZjwzAdd from '../../../../static/form/ZjwzAdd.vue'
export default {
  components: {
    ZjwzAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Zjwzgl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/ZjwzUpdate.vue